import axios from 'axios'
import {i18n} from './i18n.js'

export default function getLang (lang){
  // if (!listLanguages.includes(lang)) { lang = 'en' }
  /* send request */
  var language = lang
  if(!language){
    // language = window.navigator ? (window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage) : "en";
    language = navigator.language || navigator.userLanguage
    language = language.substr(0, 2).toLowerCase();
    console.log('MY LANG', language)
  }
  if(!['en', 'ru'].includes(language)){
    language = 'en'
  }

  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
  axios
    .get(sessionStorage.getItem('token') ? `/api/v1/translations/lang?token=${sessionStorage.getItem('token')}` : `/api/v1/translations/lang`)
    .then(response => {
      console.log("languages", response.data)
      i18n.setLocaleMessage(response.data.language, response.data)
      i18n.locale = language
      console.log("l18n", i18n)
    })
    .catch(error => {
      console.log('An error occurred:', error)
    })
}


